import PinViewModal from './PinViewModal';

export default PinViewModal;
